import { render, staticRenderFns } from "./ChartItem.vue?vue&type=template&id=10d5ed12&scoped=true&"
import script from "./ChartItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./ChartItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ChartItem.vue?vue&type=style&index=0&id=10d5ed12&prod&lang=scss&scoped=true&"
import style1 from "./ChartItem.vue?vue&type=style&index=1&id=10d5ed12&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d5ed12",
  null
  
)

export default component.exports